"use client";
import { FC, ReactNode } from "react";
import { usePathname } from "next/navigation";

const Main: FC<{ children: ReactNode }> = ({ children }) => {
  const pathname = usePathname();
  const pageClass = pathname?.split("/")[1] || "home";

  return (
    <main className={`container page-${pageClass}`}>
      {children}
    </main>
  );
};

export default Main;
